<template>
  <q-list v-if="groupNames.length" bordered separator class="rounded-borders">
    <template  v-for="(groupName, index) in groupNames" :key="index">
    <expansion-item
        :label="groupLabel(groupName)"
        class="text-weight-medium"
    >
      <q-separator />
      <q-list separator>
        <q-item v-for="item in items[groupName]" :key="item.id" class="items-center text-weight-regular">
          <q-item-section>
            <div class="row items-center q-col-gutter-x-md">
              <q-item-label class="col-3">
                <common-link :label="item.title" :href="$route('project.object.show', {project_id: project.id, object_id: item.id})" :params="itemParams(item)" />
              </q-item-label>
              <div class="col">
                {{item.type}}
              </div>
            </div>
          </q-item-section>
          <q-item-section side>
            <div class="row items-center">
              {{ $formatDateTime(item.updated_at) }}
            </div>
          </q-item-section>
        </q-item>
      </q-list>
    </expansion-item>
    </template>
  </q-list>
</template>

<script>
export default {
  props: {
    items: {
      type: Object,
      default: () => {
        return {}
      }
    },
    project: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    groupNames () {
      return Object.keys(this.items)
    }
  },
  methods: {
    groupLabel (groupName) {
      const count = this.items[groupName].length
      return `${groupName} (${count})`
    },
    itemParams(item) {
      return {
        project_id: this.project.id,
        object_id: item.id
      }
    }
  }
}
</script>
